import { render, staticRenderFns } from "./teacherDialog.vue?vue&type=template&id=20af5876&scoped=true"
import script from "./teacherDialog.vue?vue&type=script&lang=js"
export * from "./teacherDialog.vue?vue&type=script&lang=js"
import style0 from "./teacherDialog.vue?vue&type=style&index=0&id=20af5876&prod&lang=scss"
import style1 from "./teacherDialog.vue?vue&type=style&index=1&id=20af5876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af5876",
  null
  
)

export default component.exports